export default "__VITE_ASSET__C$0L_TyZ__"